"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONLoader = void 0;
const Namespace_js_1 = require("./Namespace.js");
class JSONLoader {
    namespaces = {};
    namespaceCount = 0;
    injectLoaders(loaders) {
        const namespaceKey = this.generateNamespaceKey();
        const namespace = new Namespace_js_1.Namespace(loaders);
        this.namespaces[namespaceKey] = namespace;
    }
    generateNamespaceKey() {
        this.namespaceCount += 1;
        return `namespace${this.namespaceCount}`;
    }
    async get(locale) {
        const namespaces = Object.values(this.namespaces);
        const messages = await Promise.all(namespaces.map((namespace) => namespace.load(locale)));
        return Object.assign({}, ...messages);
    }
    exists(locale) {
        const namespaces = Object.values(this.namespaces);
        return namespaces.some((namespace) => namespace.hasLocale(locale));
    }
    forEachLoaded(callback) {
        const namespaces = Object.values(this.namespaces);
        const cache = {};
        for (const namespace of namespaces) {
            namespace.forEachLoadedLocale((locale, messages) => {
                cache[locale] = { ...cache[locale], ...messages };
            });
        }
        for (const locale of Object.keys(cache)) {
            callback(cache[locale], locale);
        }
    }
}
exports.JSONLoader = JSONLoader;
//# sourceMappingURL=JsonLoader.js.map